import {AxiosError} from 'axios';
import {ErrorData, ErrorDataResponse} from '../../../../backend/responses/error-response';
import {translations} from '../../../../i18n/translations';

type CareServiceError = {
  title: string;
  message: string;
  code: number | undefined;
};

export function handleCareServiceEditError(error: any): CareServiceError {
  const axiosError = error as AxiosError;
  console.error('Care service error', error);
  const status = axiosError.response?.status;
  const errors = (axiosError.response?.data as ErrorDataResponse | undefined)?.errors;
  let err: CareServiceError = {title: '', message: '', code: status};

  switch (status) {
    case 400:
      err = detectError(errors, status);
      break;
    case 404:
      err.title = translations.care_services.toasts.edit.error.not_found.title;
      err.message = translations.care_services.toasts.edit.error.not_found.message;
      break;
    case 403:
      err.title = translations.care_services.toasts.edit.error.access_denied.title;
      err.message = translations.care_services.toasts.edit.error.access_denied.message;
      break;
    default:
      err.title = translations.care_services.toasts.edit.error.unknown.title;
      err.message = translations.care_services.toasts.edit.error.unknown.message;
      break;
  }

  return err;
}

function detectError(errors?: ErrorData[], status?: number): CareServiceError {
  const ERROR_CODE_MAP: Record<string, CareServiceError> = {
    'body_repetition.frequencyValue_frequencyvalue-is-required-when-repetition-is-present': {
      title: translations.care_services.toasts.edit.error.repetition_required.title,
      message: translations.care_services.toasts.edit.error.repetition_required.message,
      code: status,
    },
    'body_endsAt_endsat-must-be-after-startsat': {
      title: translations.care_services.toasts.edit.error.end_date_invalid.title,
      message: translations.care_services.toasts.edit.error.end_date_invalid.message,
      code: status,
    },
    "Repetition removal on a series requires update scope to be 'this-and-future-instances' or 'all-instances'.":
      {
        title: translations.care_services.toasts.edit.error.repetition_removal_scope.title,
        message: translations.care_services.toasts.edit.error.repetition_removal_scope.message,
        code: status,
      },
    "Repetition change requires update scope to be 'this-and-future-instances' or 'all-instances'.":
      {
        title: translations.care_services.toasts.edit.error.repetition_change_scope.title,
        message: translations.care_services.toasts.edit.error.repetition_change_scope.message,
        code: status,
      },
  };

  const anyErrorFound = errors?.find((e) => ERROR_CODE_MAP[e.code ?? e.msg]);

  // Specific error found
  if (anyErrorFound) return ERROR_CODE_MAP[anyErrorFound.code ?? anyErrorFound.msg];

  // Fallback to invalid data error
  return {
    title: translations.care_services.toasts.edit.error.invalid_data.title,
    message: translations.care_services.toasts.edit.error.invalid_data.message,
    code: status,
  };
}
